const schema = () => ({
  title: 'Sommaire carte',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['links'],
    },
  ],
  properties: {
    links: {
      title: 'Liens',
      type: 'array',
      widget: 'object_list',
      schema: {
        title: 'Lien',
        addMessage: 'Ajouter un lien',
        fieldsets: [
          {
            id: 'default',
            title: 'Lien',
            fields: ['label', 'anchor'],
          },
        ],
        properties: {
          label: { title: 'Libellé', type: 'string' },
          anchor: {
            title: 'Ancre (sans #)',
            type: 'string',
            description:
              'Identifiant de la section visée. Doit correspondre au titre slugifié de la section (ex. « entrees »).',
          },
        },
        required: ['anchor'],
      },
    },
  },
  required: [],
});

export default schema;
